<agr-dialog [formGroup]="formGroup" (confirm)="save()" (cancel)="cancel()" [data]="data">
  <div class="flex--column spacing--margin-top">
    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'sustainability.year' | translate }}</mat-label>
      <mat-select
        [hideSingleSelectionIndicator]="true"
        formControlName="year"
        data-test="resource-edit-item__year"
      >
        <mat-option *ngFor="let year of years$ | async" [value]="year">
          {{ year }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'sustainability.resource.water' | translate }}</mat-label>
      <input
        matInput
        agrNumber
        [step]="0.01"
        formControlName="water"
        data-test="resource-edit-item__water"
      />
      <span matTextSuffix class="form-field-suffix">m³</span>
      <mat-error *ngIf="formGroup.controls.water.hasError('min')">
        {{ 'sustainability.resource.water-error' | translate }}
      </mat-error>
    </mat-form-field>

    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'sustainability.resource.electricity' | translate }}</mat-label>
      <input
        matInput
        agrNumber
        [step]="0.01"
        formControlName="electricity"
        data-test="resource-edit-item__electricityWind"
      />
      <span matTextSuffix class="form-field-suffix">kWh</span>
      <mat-error *ngIf="formGroup.controls.electricity.hasError('min')">
        {{ 'sustainability.resource.electricity-error' | translate }}
      </mat-error>
    </mat-form-field>

    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'sustainability.resource.electricity-photovoltaic' | translate }}</mat-label>
      <input
        matInput
        agrNumber
        [step]="0.01"
        formControlName="electricityPhotovoltaic"
        data-test="resource-edit-item__electricityPv"
      />
      <span matTextSuffix class="form-field-suffix">kWh</span>
      <mat-error *ngIf="formGroup.controls.electricityPhotovoltaic.hasError('min')">
        {{ 'sustainability.resource.electricity-photovoltaic-error' | translate }}
      </mat-error>
    </mat-form-field>

    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'sustainability.resource.electricity-wind' | translate }}</mat-label>
      <input
        matInput
        agrNumber
        [step]="0.01"
        formControlName="electricityWind"
        data-test="resource-edit-item__electricityWind"
      />
      <span matTextSuffix class="form-field-suffix">kWh</span>
      <mat-error *ngIf="formGroup.controls.electricityWind.hasError('min')">
        {{ 'sustainability.resource.electricity-wind-error' | translate }}
      </mat-error>
    </mat-form-field>

    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'sustainability.resource.natural-gas' | translate }}</mat-label>
      <input
        matInput
        agrNumber
        [step]="0.01"
        formControlName="naturalGas"
        data-test="resource-edit-item__naturalGas"
      />
      <span matTextSuffix class="form-field-suffix">m³</span>
      <mat-error *ngIf="formGroup.controls.naturalGas.hasError('min')">
        {{ 'sustainability.resource.natural-gas-error' | translate }}
      </mat-error>
    </mat-form-field>

    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'sustainability.resource.diesel' | translate }}</mat-label>
      <input
        matInput
        agrNumber
        [step]="0.01"
        formControlName="diesel"
        data-test="resource-edit-item__diesel"
      />
      <span matTextSuffix class="form-field-suffix">L</span>
      <mat-error *ngIf="formGroup.controls.diesel.hasError('min')">
        {{ 'sustainability.resource.diesel-error' | translate }}
      </mat-error>
    </mat-form-field>

    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'sustainability.resource.gasoline' | translate }}</mat-label>
      <input
        matInput
        agrNumber
        [step]="0.01"
        formControlName="gasoline"
        data-test="resource-edit-item__gasoline"
      />
      <span matTextSuffix class="form-field-suffix">L</span>
      <mat-error *ngIf="formGroup.controls.gasoline.hasError('min')">
        {{ 'sustainability.resource.gasoline-error' | translate }}
      </mat-error>
    </mat-form-field>

    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'sustainability.resource.propane-lpg' | translate }}</mat-label>
      <input
        matInput
        agrNumber
        [step]="0.01"
        formControlName="propaneLpg"
        data-test="resource-edit-item__propaneLpg"
      />
      <span matTextSuffix class="form-field-suffix">L</span>
      <mat-error *ngIf="formGroup.controls.propaneLpg.hasError('min')">
        {{ 'sustainability.resource.propane-lpg-error' | translate }}
      </mat-error>
    </mat-form-field>

    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'sustainability.resource.coal' | translate }}</mat-label>
      <input
        matInput
        agrNumber
        [step]="0.01"
        formControlName="coal"
        data-test="resource-edit-item__coal"
      />
      <span matTextSuffix class="form-field-suffix">KG</span>
      <mat-error *ngIf="formGroup.controls.coal.hasError('min')">
        {{ 'sustainability.resource.coal-error' | translate }}
      </mat-error>
    </mat-form-field>
  </div>
</agr-dialog>
